import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';
import { fmtMoney, fmtShortDate } from '../helpers';
import type { Transaction } from '../types';

type Props = {
  transactions: ReadonlyArray<Transaction>;
  onViewAll?: () => void;
  onReviewTransaction?: (t: Transaction) => void;
};

const PILL_STYLE: Record<Transaction['status'], React.CSSProperties> = {
  ok:     { background: '#E8F5F0', color: '#0D8050' },
  auto:   { background: '#F3EEFC', color: '#6B46C1' },
  review: { background: '#FDF4E3', color: '#B45309' },
};

const PILL_LABEL: Record<Transaction['status'], string> = {
  ok: 'Categorized',
  auto: 'Auto-matched',
  review: 'Review',
};

export default function RecentTransactions({ transactions, onViewAll, onReviewTransaction }: Props) {
  return (
    <div style={{
      background: C.card,
      border: '1px solid ' + C.line,
      borderRadius: 14,
      padding: '20px 22px',
      fontFamily: F.family,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>Recent transactions</h3>
        <span onClick={onViewAll} style={{ fontSize: 12, color: C.tealInk, fontWeight: 700, cursor: 'pointer' }}>
          View all
        </span>
      </div>

      {transactions.length === 0 ? (
        <div style={{ fontSize: 13, color: C.sub, padding: '18px 0', fontStyle: 'italic' }}>
          No transactions yet. Connect your bank or import to get started.
        </div>
      ) : (
        transactions.map((t, i) => (
          <div
            key={t.id}
            onClick={() => t.status === 'review' && onReviewTransaction?.(t)}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 110px 90px',
              gap: 12,
              padding: '10px 0',
              borderBottom: i === transactions.length - 1 ? '0' : '1px solid ' + C.lineSoft,
              fontSize: 13,
              alignItems: 'center',
              cursor: t.status === 'review' ? 'pointer' : 'default',
            }}
          >
            <div style={{ fontWeight: 600, color: C.ink }}>
              {t.name}
              <span style={{ fontSize: 11.5, color: C.sub, fontWeight: 400, display: 'block', marginTop: 1 }}>
                {fmtShortDate(t.date)} · {t.subtitle}
              </span>
            </div>
            <div style={{
              textAlign: 'right',
              fontFamily: 'ui-monospace, Menlo, monospace',
              fontWeight: 600,
              fontVariantNumeric: 'tabular-nums',
              color: t.amount >= 0 ? C.green : C.ink,
            }}>
              {t.amount >= 0 ? '+' : ''}{fmtMoney(t.amount)}
            </div>
            <div style={{
              fontSize: 10.5, fontWeight: 700,
              padding: '2px 7px', borderRadius: 999, textAlign: 'center',
              ...PILL_STYLE[t.status],
            }}>
              {PILL_LABEL[t.status]}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
